/* Este archivo puede quedar incluido más de una vez en la misma página
   (cada sección que lo necesita lo carga por su cuenta). Esta guarda evita
   que las secciones se inicialicen dos veces. */
if (!window.__gbScriptsInit) {
  window.__gbScriptsInit = true;

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initCountUp();
    initFaq();
    initCarrusel();
    initGaleria();
    initVariantes();
  });
}

/* Revela elementos .gb-reveal al entrar en pantalla ---------------------- */
function initReveal() {
  var els = document.querySelectorAll('.gb-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('gb-visible'); });
    return;
  }
  var vh = window.innerHeight || document.documentElement.clientHeight;
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('gb-visible');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
  els.forEach(function (el) {
    var rect = el.getBoundingClientRect();
    if (rect.top < vh && rect.bottom > 0) {
      el.classList.add('gb-visible');
    } else {
      obs.observe(el);
    }
  });
}

/* Cuenta números al entrar en pantalla ------------------------------------ */
function initCountUp() {
  var els = document.querySelectorAll('[data-gb-count]');
  if (!els.length) return;
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var target = parseFloat(el.getAttribute('data-gb-count')) || 0;
      var decimals = (el.getAttribute('data-gb-count').split('.')[1] || '').length;
      obs.unobserve(el);
      if (prefersReduced) {
        el.textContent = target.toFixed(decimals);
        return;
      }
      var start = 0;
      var duration = 1400;
      var startTime = null;
      function step(ts) {
        if (!startTime) startTime = ts;
        var progress = Math.min((ts - startTime) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        var value = start + (target - start) * eased;
        el.textContent = value.toFixed(decimals);
        if (progress < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    });
  }, { threshold: 0.5 });
  els.forEach(function (el) { obs.observe(el); });
}

/* Acordeón de preguntas frecuentes ---------------------------------------- */
function initFaq() {
  var items = document.querySelectorAll('.gb-faq-item');
  if (!items.length) return;
  items.forEach(function (item) {
    var btn = item.querySelector('.gb-faq-pregunta');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var isOpen = item.classList.contains('gb-faq-open');
      items.forEach(function (other) { other.classList.remove('gb-faq-open'); other.querySelector('.gb-faq-pregunta').setAttribute('aria-expanded', 'false'); });
      if (!isOpen) {
        item.classList.add('gb-faq-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });
}

/* Carrusel de reseñas (loop infinito con botones) ------------------------- */
function initCarrusel() {
  document.querySelectorAll('[data-gb-carrusel]').forEach(function (wrap) {
    var track = wrap.querySelector('.gb-carrusel-track');
    var prev = wrap.querySelector('[data-gb-prev]');
    var next = wrap.querySelector('[data-gb-next]');
    if (!track) return;
    var card = track.querySelector('.gb-resena-card');
    function step() {
      return card ? card.getBoundingClientRect().width + 20 : 300;
    }
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
  });
}

/* Galería del producto: miniatura -> imagen principal ---------------------- */
function initGaleria() {
  var galeria = document.querySelector('[data-gb-galeria]');
  if (!galeria) return;
  var principal = galeria.querySelector('[data-gb-imagen-principal]');
  var thumbs = galeria.querySelectorAll('[data-gb-thumb]');
  if (!principal || !thumbs.length) return;
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var src = thumb.getAttribute('data-gb-full');
      var alt = thumb.getAttribute('data-gb-alt') || '';
      if (!src) return;
      principal.style.opacity = '0';
      setTimeout(function () {
        principal.src = src;
        principal.alt = alt;
        principal.style.opacity = '1';
      }, 150);
      thumbs.forEach(function (t) { t.classList.remove('gb-thumb-activa'); });
      thumb.classList.add('gb-thumb-activa');
    });
  });
}

/* Selector de variantes del producto --------------------------------------- */
function initVariantes() {
  var form = document.querySelector('[data-gb-form-producto]');
  if (!form) return;
  var variantsData = form.querySelector('[data-gb-variants-json]');
  if (!variantsData) return;
  var variants;
  try { variants = JSON.parse(variantsData.textContent); } catch (e) { return; }

  var optionInputs = form.querySelectorAll('[data-gb-option]');
  var idInput = form.querySelector('input[name="id"]');
  var precioEl = form.querySelector('[data-gb-precio]');
  var precioCompareEl = form.querySelector('[data-gb-precio-comparado]');
  var submitBtn = form.querySelector('[data-gb-submit]');

  function moneyFormat(cents) {
    return '$' + (cents / 100).toLocaleString('es-CO', { minimumFractionDigits: 0 });
  }

  function currentSelection() {
    var sel = [];
    optionInputs.forEach(function (group) {
      var checked = group.querySelector('input:checked');
      if (checked) sel.push(checked.value);
    });
    return sel;
  }

  function findVariant() {
    var sel = currentSelection();
    return variants.find(function (v) {
      return v.options.every(function (opt, i) { return opt === sel[i]; });
    });
  }

  function actualizar() {
    var variant = findVariant();
    if (!variant) return;
    if (idInput) idInput.value = variant.id;
    if (precioEl) precioEl.textContent = moneyFormat(variant.price);
    if (precioCompareEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        precioCompareEl.textContent = moneyFormat(variant.compare_at_price);
        precioCompareEl.style.display = '';
      } else {
        precioCompareEl.style.display = 'none';
      }
    }
    if (submitBtn) {
      if (variant.available) {
        submitBtn.disabled = false;
        submitBtn.setAttribute('data-gb-estado', 'disponible');
      } else {
        submitBtn.disabled = true;
        submitBtn.setAttribute('data-gb-estado', 'agotado');
      }
    }
  }

  optionInputs.forEach(function (group) {
    group.querySelectorAll('input').forEach(function (input) {
      input.addEventListener('change', actualizar);
    });
  });

  actualizar();
}
